export default __webpack_public_path__ + "static/media/twProfile.b37fa65f.jpeg";